<template>
    <div class="operate-log">
        <ListSearch ref="listSearch" hide-page>
            <template #forms>
                <el-form-item label="用户姓名">
                    <el-select v-model="formSearch.userId" placeholder="请选择用户姓名" @change="reset" filterable>
                        <el-option
                            v-for="(item, index) in userList"
                            :key="index"
                            :label="item.userName"
                            :value="item.userId"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker
                        v-model="formSearch.date"
                        @change="reset"
                        type="daterange"
                        range-separator="-"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :clearable="false"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <div class="buttons">
                    <el-button type="primary" @click="reset">查询</el-button>
                </div>
            </template>
        </ListSearch>
        <el-table
            v-if="render"
            :data="tableData"
            border
            max-height="700"
            v-el-table-infinite-scroll="load"
            infinite-scroll-disabled="disabled"
            v-loading="loading"
            style="height: 100%"
            class="targetTable"
        >
            <el-table-column align="center" type="index"></el-table-column>
            <el-table-column align="center" label="操作时间" prop="logTime"></el-table-column>
            <el-table-column align="center" label="操作详情" prop="action"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import ListSearch from '@/components/ListSearch/ListSearch';
import elTableInfiniteScroll from 'el-table-infinite-scroll';
export default {
    data() {
        return {
            formSearch: {
                userId: '',
                date: [dayjs().add(-7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                disabledDate(time) {
                    let date = dayjs()
                        .add(-1, 'year')
                        .valueOf(); // 可选范围，最近一年
                    return time.getTime() > Date.now() || time.getTime() < date;
                }
            },
            userList: [{userName: '我的', userId: 'mine'}],
            render: true,
            tableData: [],
            loading: false,
            page: 0,
            size: 20,
            noMore: false
        };
    },
    components: {
        ListSearch
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    computed: {
        disabled() {
            return this.loading || this.noMore;
        }
    },
    created() {
        this.getUserList();
    },
    methods: {
        // 获取用户列表
        getUserList() {
            this.$http
                .get('/account/page/v1', {
                    page: 0,
                    size: 9999
                })
                .then(res => {
                    this.userList = res.content;
                });
        },
        // 重置
        reset() {
            this.noMore = false;
            this.page = 0;
            this.tableData = [];
            this.render = false;
            this.$nextTick(() => {
                this.render = true;
            });
        },
        load() {
            this.loading = true;
            setTimeout(() => {
                this.$http
                    .get('/log/personal/v1', {
                        userId: this.formSearch.userId,
                        startDate: this.formSearch.date[0],
                        endDate: this.formSearch.date[1],
                        page: this.page,
                        size: this.size
                    })
                    .then(res => {
                        this.page++;
                        this.tableData = this.tableData.concat(res.content);
                        if (res.last) {
                            this.noMore = true;
                            const tableDom = document
                                .querySelector('.targetTable')
                                .querySelector('.el-table__body-wrapper');
                            const tipDom = document.createElement('p');
                            if (this.tableData.length > 0) {
                                tipDom.innerHTML = '-- 已加载全部数据 --';
                                tipDom.className = 'tipTable';
                                tableDom.appendChild(tipDom);
                            }
                        }
                        this.loading = false;
                    });
            }, 300);
        }
    }
};
</script>

<style lang="scss">
.operate-log {
    .el-table th {
        background-color: #f6f9fd;
    }
}
</style>